import type { World } from '../sim/world';
import type { TilePoint } from '../sim/mobile';

/**
 * The average tile of every mobile in the world. Falls back to the map's centre
 * when the world holds no mobiles (it always holds the NPC roster on the running
 * server, so the fallback is only a defensive guard).
 */
export function worldCentroid(world: World): TilePoint {
  let sx = 0;
  let sy = 0;
  let n = 0;
  for (const entity of world.all()) {
    if (!entity.mobile) continue;
    const p = entity.mobile.renderPosition();
    sx += p.x;
    sy += p.y;
    n += 1;
  }
  if (n === 0) return { x: world.map.width / 2, y: world.map.height / 2 };
  return { x: sx / n, y: sy / n };
}

/**
 * Where to aim the **spectator** backdrop camera (the login screen): the exact
 * tile the player will spawn on, so the world framed behind the translucent login
 * modal is already centred on the spawn tile and entering causes no camera jump
 * (issue #193). The spawn tile rides the map snapshot ({@link World.map}); when a
 * map declares none (the generated test grid) we fall back to the crowd centroid,
 * so the backdrop still frames the busy bank rather than an empty corner.
 */
export function backdropCameraTile(world: World): TilePoint {
  return world.map.playerSpawn ?? worldCentroid(world);
}
